import PropTypes from "prop-types";
import classNames from "classnames";
import { forwardRef } from "react";

const Backdrop = forwardRef(({ className, children, open }, ref) => {

  return (
    <div
      ref={ref}
      className={classNames(
        "fixed z-[100] top-0 bottom-0 right-0 left-0 bg-black/60 transition-transform duration-500 ease-in-out",
        {
          "translate-y-0": open,
          "translate-y-full": !open,
        },
        className
      )}
    >
      {children}
    </div>
  );
});

Backdrop.propTypes = {
  ClassName: PropTypes.string,
  children: PropTypes.node,
  open: PropTypes.bool,
};

Backdrop.defaultProps = {
  open: false,
};

export default Backdrop;
